import React from 'react';

import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import api from '../../../common/services/api';

function TagsInput({
  id,
  value,
  onChange,
  suggestionsEndpoint = '',
  suggestionsFilterParam = 'filter_query',
}) {
  const loadOptions = inputValue => new Promise((resolve) => {
    api
      .post(suggestionsEndpoint, {
        [suggestionsFilterParam]: inputValue,
      })
      .then((response) => {
        resolve(
          response.data.data.map(tag => ({
            value: tag.slug,
            label: tag.slug,
          })),
        );
      })
      .catch((error) => {
        console.error(error);
      });
  });

  return (
    <AsyncCreatableSelect
      placeholder="Selecteer.."
      loadingMessage={() => 'Aan het laden..'}
      formatCreateLabel={inputValue => `Maak tag aan voor '${inputValue}'`}
      noOptionsMessage={({ inputValue }) => {
        if (!inputValue) {
          return 'Typ om opties te vinden';
        }
        return `Geen opties gevonden voor de zoekterm '${inputValue}'`;
      }}
      inputId={id}
      loadOptions={loadOptions}
      isClearable
      isMulti
      value={value.map(v => ({ value: v, label: v }))}
      onChange={(nextValue) => {
        onChange(Array.isArray(nextValue) ? nextValue.map(v => v.label) : [nextValue.label]);
      }}
    />
  );
}

export default TagsInput;
